export default {
  path: '/ReqCer',
  name: 'ReqCer',
  component: () => import('../views/layouts/ReqCer.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/',
      name: 'ReqCerList',
      component: () => import('../views/pages/ReqCer/ReqCerUserList.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'salary/:guid',
      name: 'ReqCerSalary',
      component: () => import('../views/pages/ReqCer/ReqCerSalary.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'list/:guid',
      name: 'ReqCerList',
      component: () => import('../views/pages/ReqCer/ReqCerUserList.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'info/:cercode/:type',
      name: 'ReqCerInfo',
      component: () => import('../views/pages/ReqCer/ReqCerInfo.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'add/:guid',
      name: 'ReqCerPermission',
      component: () =>
        import('../views/pages/ReqCer/ReqCerPermission.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'admin',
      name: 'ReqCerAdminList',
      component: () => import('../views/pages/ReqCer/ReqCerAdminList.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'preview/:cercode',
      name: 'ReqCerPreview',
      component: () => import('../views/pages/ReqCer/ReqCerPreview.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'empretire',
      name: 'ReqCerSalaryOld',
      component: () => import('../views/pages/ReqCer/ReqCerSalaryOld.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'execuni',
      name: 'ReqCerManageSignature',
      component: () =>
        import('../views/pages/ReqCer/ReqCerManageSignature.page.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
